import React from 'react';
import { toast } from 'react-toastify';
import { validateImageFile } from '../../utils/fileValidation';

const ProfileImageTab = ({ imageSrc, onUpload }) => {
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    const { valid, error } = validateImageFile(file);
    if (!valid) {
      toast.error(error);
      e.target.value = '';
      return;
    }
    onUpload(file);
  };

  return (
    <div>
      <label htmlFor="profile-image-upload">Immagine Profilo:</label>
      <input
        id="profile-image-upload"
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
      />
      {imageSrc && (
        <img
          src={imageSrc}
          alt="Immagine Profilo"
          style={{ width: '150px', height: '150px', marginTop: '10px' }}
        />
      )}
    </div>
  );
};

export default ProfileImageTab;
